import { Dispatch } from "redux"
import projectApi from "../../api-wrapper/project/project"
import { ProjectsAction, ProjectsActionTypes } from "../types/projectsList"

const fetchProjectsList = () => {
  return async (dispatch: Dispatch<ProjectsAction>) => {
    try {
      dispatch({
        type: ProjectsActionTypes.FETCH_PROJECTS_LIST,
      })
      const projects = await projectApi.getProjectsList()
      dispatch({
        type: ProjectsActionTypes.FETCH_PROJECTS_LIST_SUCCESS,
        payload: projects,
      })
    } catch (e) {
      dispatch({
        type: ProjectsActionTypes.FETCH_PROJECTS_LIST_ERROR,
        payload: "Default orders load error",
      })
    }
  }
}

const projectsActions = {
  fetchProjectsList,
}

export default projectsActions
